import axios from "axios";
import { DefaultModel } from "../models/IModel";
import Partner, { NearbyAttractionItem } from "../models/Partner";
import User from "../models/User";
import http from "./http";

export async function getListPartnerService(
	inPage: number,
	inPerPage: number,
	name?: string,
	active?: string,
	store?: string,
	nameUser?: string,
	country?: string,
	destinationId?: string,
	noLocation?: boolean,
	banned?: string | null
): Promise<{
	data: Partner[];
	count: number;
}> {
	const params: any = {
		...(inPage && { page: inPage }),
		...(inPerPage && { perPage: inPerPage || 50 }),
		...(name && { name: name }),
		...(active && { status: active }),
		...(store && { ownerUserId: store }),
		...(nameUser && { name: nameUser }),
		...(country && { country: country }),
		...(destinationId && { destinationId: destinationId }),
		...(noLocation && { noLocation: "true" }),
		...(banned === "true" || banned === "false" ? { banned } : {}),
	};
	let results = await http.get(`/partners-by-admin?${new URLSearchParams(params).toString()}`);
	return {
		data: DefaultModel.parseList<Partner>(results.data.docs, () => new Partner()),
		count: results.data.total,
	};
}

// ── MỘT CỬA đổi trạng thái vòng đời station ──────────────────────────────────
// Gom 3 lời gọi rời rạc (updateActivePartner · banPartnerAdmin · unbanPartnerAdmin)
// về một chỗ. Ba hàm cũ GIỮ NGUYÊN bên dưới — chưa gỡ, để không phá chỗ khác đang gọi.

export type StatusBlocker = {
	code: string;
	count?: number;
	minLength?: number;
	clearable?: boolean;
	owedToWhalelo?: number;
	owedToStation?: number;
};

export type StatusOption = {
	status: string;
	label: string;
	allowed: boolean;
	blockers: StatusBlocker[];
	effects: { field: string; to: unknown; note?: string }[];
	needsReason: boolean;
	canForce: boolean;
};

export type StatusOptionsResponse = {
	partnerId: number;
	partnerName: string;
	current: string;
	currentLabel: string;
	facts: {
		hasCoordinates: boolean;
		permanentlyClosed: boolean;
		temporarilyClosed: boolean;
		balance: number;
		owedToWhalelo: number;
		owedToStation: number;
		openOrderCount: number;
		luggageCount: number;
	};
	options: StatusOption[];
};

/** Đọc đủ 5 lựa chọn kèm lý do chặn — gọi khi MỞ hộp thoại, trước khi người dùng chọn gì. */
export const getStationStatusOptions = async (id: string): Promise<StatusOptionsResponse> => {
	const { data } = await http.get(`/partners-by-admin/${id}/status-options`);
	return data;
};

/**
 * Đổi trạng thái. Server chấm LẠI điều kiện, nên 422 kèm `blockers` là chuyện bình
 * thường chứ không phải sự cố — dữ liệu có thể đổi giữa lúc mở hộp thoại và lúc bấm.
 */
export const changeStationStatus = async (
	id: string,
	body: { status: string; reason?: string; force?: boolean; forceReason?: string; clearClosure?: boolean }
) => {
	const { data } = await http.patch(`/partners-by-admin/${id}/status`, body);
	return data;
};

/**
 * Khoá trạm.
 *
 * Backend CHẶN nếu trạm còn khách chưa tới ngày lấy đồ — trả 409 kèm
 * `{ code: "PartnerHasLuggageInStorage", ordersInStorage: N }`.
 * Truyền `force` + `forceReason` để khoá khẩn, bỏ qua chặn đó.
 */
export const banPartnerAdmin = async (id: string, reason: string, force?: boolean, forceReason?: string) => {
	const { data } = await http.post(`/admin/partners/${id}/ban`, {
		reason,
		...(force ? { force: true, forceReason: forceReason ?? "" } : {}),
	});
	return data;
};

export const unbanPartnerAdmin = async (id: string, note?: string) => {
	const { data } = await http.post(`/admin/partners/${id}/unban`, { note: note ?? "" });
	return data;
};

/**
 * Admin đặt tài khoản là CHUỖI (enabled=true) hay ĐIỂM LẺ (false) — Quân chốt 08/10/2026.
 * Backend: PATCH /admin/partners/:id/chain-mode (ChainController.setChainMode, gác partners.manage).
 * 409 = chưa migrate hoặc chuỗi đóng băng (email dùng chung) — message server nêu rõ.
 */
export const setPartnerChainMode = async (
	id: string,
	enabled: boolean
): Promise<{ storeId: number | null; chainModeEnabled: boolean; chainModeChangedAt: string | null }> => {
	const { data } = await http.patch(`/admin/partners/${id}/chain-mode`, { enabled });
	return data;
};

function parseOptionalCoordinate(value: string | undefined): number | undefined {
	const raw = String(value ?? "")
		.trim()
		.replace(",", ".");
	if (!raw) return undefined;
	const n = parseFloat(raw);
	return Number.isFinite(n) ? n : undefined;
}

export const PostPartnerAdmin = async (
	name: string,
	email: string,
	phone: string,
	password: string,
	address: string,
	addressText: string,
	note: string,
	phonePrefix: string,
	rateReview: string,
	reviewCount: string,
	displayName: string,
	displayAddress: string,
	emailPartner?: string,
	isSelect?: boolean,
	stationCom?: number,
	minimumPayout?: number,
	pubRate?: number,
	lat?: string,
	long?: string,
	destinationId?: string
) => {
	const latNum = parseOptionalCoordinate(lat);
	const longNum = parseOptionalCoordinate(long);
	const dest = String(destinationId ?? "").trim();

	let { data } = await http.post(`/partner`, {
		email: email,
		password: password,
		name: name,
		phone: phone,
		phonePrefix: phonePrefix,
		address: address,
		addressText: addressText,
		note: note,
		workTime: "",
		rateReview: rateReview,
		reviewCount: reviewCount,
		displayName: displayName,
		displayAddress: displayAddress,
		...(emailPartner && { storeOwnerUserId: emailPartner }),
		...(isSelect && { generateStoreEmail: isSelect ? true : false }),
		...(stationCom != null && stationCom > 0 ? { stationCom } : {}),
		...(minimumPayout != null && minimumPayout > 0 ? { minimumPayout } : {}),
		...(pubRate != null && pubRate > 0 ? { pubRate } : {}),
		...(latNum !== undefined ? { lat: latNum } : {}),
		...(longNum !== undefined ? { long: longNum } : {}),
		...(dest ? { destinationId: dest } : {}),
	});
	return data;
};

export const PutPartnerAdmin = async (
	id: string,
	name: string,
	address: string,
	addressText: string,
	note: string,
	lat: string,
	long: string,
	displayName: string,
	displayAddress: string,
	price: number | null,
	insurancePrice: number | null,
	reviewScore: number | null | string,
	reviewQuantity: number | null | string,
	locationId: string,
	workSchedule: {
		date: {
			from: string;
			to: string;
		};
		hour: {
			from: string;
			to: string;
		};
	}[],
	hotline: string[],
	emailPartner: string,
	stationEmail?: string,
	stationCom?: number | null,
	minimumPayout?: number | null,
	maximumPayout?: number | null,
	pubRate?: number | null,
	rateLimitMin?: number | null,
	rateLimitMax?: number | null,
	closureExceptionConfig?: object | null,
	feeSmall?: number | null,
	feeMedium?: number | null,
	feeLarge?: number | null,
	imageSmall?: string | null,
	imageMedium?: string | null,
	imageLarge?: string | null,
	mapImage?: string | null,
	nearbyAttractionsContent?: NearbyAttractionItem[] | null,
	stationShowMeetTab?: boolean | null,
	stationShowNearbyTab?: boolean | null,
	meetStationSubtitle?: string | null
) => {
	let { data } = await http.put(`admin-update-partner-detail/${id}`, {
		allowName: true,
		name: name,
		allowAddress: true,
		address: address,
		addressText: addressText,
		allowAddressText: true,
		note: note,
		allowNote: true,
		...(lat != null && String(lat).trim() !== "" && String(lat).trim() !== "0" ? { lat, allowLat: true } : {}),
		...(long != null && String(long).trim() !== "" && String(long).trim() !== "0" ? { long, allowLong: true } : {}),
		displayName: displayName,
		allowDisplayName: true,
		displayAddress: displayAddress,
		allowDisplayAddress: true,

		rateReview: reviewScore,
		allowRateReview: true,
		reviewCount: reviewQuantity,
		allowReviewCount: true,
		destinationId: locationId,
		allowDestinationId: true,
		fee: price,
		allowFee: true,
		insuranceFee: insurancePrice,
		allowInsuranceFee: true,
		workTime: workSchedule,
		allowWorkTime: true,
		hotlineNumber: hotline,
		allowHotlineNumber: true,
		allowStoreOwnerUserId: true,
		storeOwnerUserId: emailPartner,
		...(stationEmail?.trim() ? { allowEmail: true, email: stationEmail.trim() } : {}),
		...(stationCom !== undefined ? { stationCom, allowStationCom: true } : {}),
		...(minimumPayout !== undefined ? { minimumPayout, allowMinimumPayout: true } : {}),
		...(maximumPayout !== undefined ? { maximumPayout, allowMaximumPayout: true } : {}),
		...(pubRate !== undefined ? { pubRate, allowPubRate: true } : {}),
		...(rateLimitMin !== undefined ? { rateLimitMin, allowRateLimitMin: true } : {}),
		...(rateLimitMax !== undefined ? { rateLimitMax, allowRateLimitMax: true } : {}),
		...(closureExceptionConfig !== undefined ? { closureExceptionConfig } : {}),
		...(feeSmall !== undefined ? { feeSmall, allowFeeSmall: true } : {}),
		...(feeMedium !== undefined ? { feeMedium, allowFeeMedium: true } : {}),
		...(feeLarge !== undefined ? { feeLarge, allowFeeLarge: true } : {}),
		...(imageSmall !== undefined ? { imageSmall, allowImageSmall: true } : {}),
		...(imageMedium !== undefined ? { imageMedium, allowImageMedium: true } : {}),
		...(imageLarge !== undefined ? { imageLarge, allowImageLarge: true } : {}),
		...(mapImage !== undefined ? { mapImage, allowMapImage: true } : {}),
		...(nearbyAttractionsContent !== undefined
			? { nearbyAttractionsContent, allowNearbyAttractionsContent: true }
			: {}),
		...(stationShowMeetTab !== undefined && stationShowMeetTab !== null
			? { stationShowMeetTab, allowStationShowMeetTab: true }
			: {}),
		...(stationShowNearbyTab !== undefined && stationShowNearbyTab !== null
			? { stationShowNearbyTab, allowStationShowNearbyTab: true }
			: {}),
		...(meetStationSubtitle !== undefined ? { meetStationSubtitle, allowMeetStationSubtitle: true } : {}),
	});
	return data;
};

/**
 * 28/10/2026: lưu tài khoản CHỦ CHUỖI thuần (không phải địa điểm) — cùng endpoint Admin nhưng chỉ bật
 * cờ allow của tên, ghi chú, email đăng nhập (+ email người đại diện cho khớp). Không gửi giá, toạ độ,
 * giờ, hotline, storeOwnerUserId ⇒ backend không đụng các cột đó.
 */
export const PutChainAccountAdmin = async (id: string, input: { name: string; note: string; email: string }) => {
	const email = input.email.trim();
	const { data } = await http.put(`admin-update-partner-detail/${id}`, {
		allowName: true,
		name: input.name,
		allowNote: true,
		note: input.note,
		...(email ? { allowEmail: true, email, allowRepresentativeEmail: true, representativeEmail: email } : {}),
	});
	return data;
};

export const PutPartnerAdminFinancialFields = async (
	id: string,
	data: {
		destinationId?: string | null;
		stationCom?: number | null;
		minimumPayout?: number | null;
		maximumPayout?: number | null;
		pubRate?: number | null;
		minBalance?: number | null;
		minBalanceEnabled?: boolean;
		minimumPayoutEnabled?: boolean;
	}
) => {
	let res = await http.put(`admin-update-partner-detail/${id}`, {
		...data,
		allowStationCom: data.stationCom !== undefined,
		allowMinimumPayout: data.minimumPayout !== undefined,
		allowMaximumPayout: data.maximumPayout !== undefined,
		allowPubRate: data.pubRate !== undefined,
		allowMinBalance: data.minBalance !== undefined,
		allowMinBalanceEnabled: data.minBalanceEnabled !== undefined,
		allowMinimumPayoutEnabled: data.minimumPayoutEnabled !== undefined,
	});
	return res.data;
};

export const PutPartnerStationLandingContent = async (
	id: string,
	data: {
		meetStationSubtitle?: string;
		nearbyAttractionsContent?: { image: string; title: string; walkingMinutes: number; description: string }[];
	}
) => {
	const res = await http.put(`admin-update-partner-detail/${id}`, {
		...(data.meetStationSubtitle !== undefined && {
			meetStationSubtitle: data.meetStationSubtitle,
			allowMeetStationSubtitle: true,
		}),
		...(data.nearbyAttractionsContent !== undefined && {
			nearbyAttractionsContent: data.nearbyAttractionsContent,
			allowNearbyAttractionsContent: true,
		}),
	});
	return res.data;
};

/** Set contract violation strike count (0–3) for a partner / station. */
export const putAdminPartnerContractViolationCount = async (id: string, contractViolationCount: number) => {
	const res = await http.put(`admin-update-partner-detail/${id}`, {
		contractViolationCount,
	});
	return res.data;
};

/**
 * Bulk-update station page V2 content fields for multiple partners.
 * Only fields explicitly set (non-undefined) will be included in the payload.
 */
export const PutPartnerBulkAdminContentFields = async (
	partnerIds: string[],
	data: {
		faqContent?: any[] | null;
		meetStationSubtitle?: string;
		stationShowMeetTab?: boolean;
		stationShowNearbyTab?: boolean;
		meetStationImages?: string[];
		nearbyStationImages?: string[];
		imagesEnabled?: boolean;
	}
) => {
	const reqData: Record<string, unknown> = {};
	if (data.faqContent !== undefined) reqData.faqContent = data.faqContent;
	if (data.meetStationSubtitle !== undefined) reqData.meetStationSubtitle = data.meetStationSubtitle;
	if (data.stationShowMeetTab !== undefined) reqData.stationShowMeetTab = data.stationShowMeetTab;
	if (data.stationShowNearbyTab !== undefined) reqData.stationShowNearbyTab = data.stationShowNearbyTab;
	if (data.meetStationImages !== undefined) reqData.meetStationImages = data.meetStationImages;
	if (data.nearbyStationImages !== undefined) reqData.nearbyStationImages = data.nearbyStationImages;
	if (data.imagesEnabled !== undefined) reqData.imagesEnabled = data.imagesEnabled;
	const res = await http.put("admin-update-partner-bulk", { partnerIds, data: reqData });
	return res.data;
};

export const PutBulkPartnerAdmin = async (
	partnerIds: string[],
	data: {
		destinationId?: string | null;
		stationCom?: number | null;
		minimumPayout?: number | null;
		minimumPayoutEnabled?: boolean;
		minBalance?: number | null;
		minBalanceEnabled?: boolean;
		maximumPayout?: number | null;
		pubRate?: number | null;
		fee?: number | null;
		insuranceFee?: number | null;
		/** Giá lưu theo cỡ túi (Small bag / Standard suitcase / Oversized). Không truyền = không đổi. */
		feeSmall?: number | null;
		feeMedium?: number | null;
		feeLarge?: number | null;
		workTime?: any;
		imagesEnabled?: boolean;
		rateLimitMin?: number;
		rateLimitMax?: number;
		localCurrencyCode?: string | null;
		generalHotline?: string | null;
		stationSupportHotline?: string | null;
		/** Same shape as single edit; null clears closure rules for all selected partners */
		closureExceptionConfig?: object | null;
		meetStationImages?: string[];
		images?: string[];
	}
) => {
	const reqData: any = {};
	if (data.destinationId !== undefined) {
		reqData.destinationId = data.destinationId;
		reqData.allowDestinationId = true;
	}
	if (data.stationCom !== undefined) {
		reqData.stationCom = data.stationCom;
		reqData.allowStationCom = true;
	}
	if (data.minimumPayout !== undefined) {
		reqData.minimumPayout = data.minimumPayout;
		reqData.allowMinimumPayout = true;
	}
	if (data.minimumPayoutEnabled !== undefined) {
		reqData.minimumPayoutEnabled = data.minimumPayoutEnabled;
		reqData.allowMinimumPayoutEnabled = true;
	}
	if (data.minBalance !== undefined) {
		reqData.minBalance = data.minBalance;
		reqData.allowMinBalance = true;
	}
	if (data.minBalanceEnabled !== undefined) {
		reqData.minBalanceEnabled = data.minBalanceEnabled;
		reqData.allowMinBalanceEnabled = true;
	}
	if (data.maximumPayout !== undefined) {
		reqData.maximumPayout = data.maximumPayout;
		reqData.allowMaximumPayout = true;
	}
	if (data.pubRate !== undefined) {
		reqData.pubRate = data.pubRate;
		reqData.allowPubRate = true;
	}
	if (data.fee !== undefined) {
		reqData.fee = data.fee;
		reqData.allowFee = true;
	}
	if (data.insuranceFee !== undefined) {
		reqData.insuranceFee = data.insuranceFee;
		reqData.allowInsuranceFee = true;
	}
	if (data.feeSmall !== undefined) {
		reqData.feeSmall = data.feeSmall;
		reqData.allowFeeSmall = true;
	}
	if (data.feeMedium !== undefined) {
		reqData.feeMedium = data.feeMedium;
		reqData.allowFeeMedium = true;
	}
	if (data.feeLarge !== undefined) {
		reqData.feeLarge = data.feeLarge;
		reqData.allowFeeLarge = true;
	}
	if (data.workTime !== undefined) {
		reqData.workTime = data.workTime;
		reqData.allowWorkTime = true;
	}
	if (data.imagesEnabled !== undefined) {
		reqData.imagesEnabled = data.imagesEnabled;
		reqData.allowImagesEnabled = true;
	}
	if (data.rateLimitMin !== undefined) {
		reqData.rateLimitMin = data.rateLimitMin;
		reqData.allowRateLimitMin = true;
	}
	if (data.rateLimitMax !== undefined) {
		reqData.rateLimitMax = data.rateLimitMax;
		reqData.allowRateLimitMax = true;
	}
	if (data.localCurrencyCode !== undefined) {
		reqData.localCurrencyCode = data.localCurrencyCode;
		reqData.allowLocalCurrencyCode = true;
	}
	if (data.generalHotline !== undefined) {
		reqData.generalHotline = data.generalHotline;
	}
	if (data.stationSupportHotline !== undefined) {
		reqData.stationSupportHotline = data.stationSupportHotline;
	}
	if (data.closureExceptionConfig !== undefined) {
		reqData.closureExceptionConfig = data.closureExceptionConfig;
		reqData.allowClosureExceptionConfig = true;
	}
	if (data.meetStationImages !== undefined) {
		reqData.meetStationImages = data.meetStationImages;
		reqData.allowMeetStationImages = true;
	}
	if (data.images !== undefined) {
		reqData.images = data.images;
		reqData.allowImages = true;
	}

	let res = await http.put(`admin-update-partner-bulk`, {
		partnerIds,
		data: reqData,
	});
	return res.data;
};

/** Toggle Meet / Nearby sections on customer `/station/:city/:id` landing page */
export const patchPartnerStationLandingSectionFlags = async (
	partnerId: string,
	flags: { stationShowMeetTab?: boolean; stationShowNearbyTab?: boolean }
) => {
	const body: Record<string, unknown> = {};
	if (flags.stationShowMeetTab !== undefined) body.stationShowMeetTab = flags.stationShowMeetTab;
	if (flags.stationShowNearbyTab !== undefined) body.stationShowNearbyTab = flags.stationShowNearbyTab;
	if (Object.keys(body).length === 0) return;
	await http.put(`admin-update-partner-detail/${partnerId}`, body);
};

export type PartnerAvailableSummaryResponse = {
	partnerId: number;
	paidAmount?: number;
	paidAmountLocal?: number;
	availableDeductionAmount?: number;
	summary: {
		availableAmount: number;
		availableAmountRaw?: number;
		minimumPayout?: number | null;
		minimumPayoutEnabled?: boolean;
		bookingCount?: number;
		availableBookingCount?: number;
		estimateBookingCount?: number;
		inTransitBookingCount?: number;
		inTransitAmount?: number;
		availableDeductionAmount?: number;
		availableBonusAmount?: number;
		availableAdjustmentAmount?: number;
		appliedAvailableDeduction?: number;
		appliedAvailableBonus?: number;
		currencyCode?: string;
		[key: string]: any;
	};
};

export const getPartnerAvailableSummary = async (id: string): Promise<PartnerAvailableSummaryResponse> => {
	const { data } = await http.get(`/admin-partners/${id}/available-summary`);
	return data;
};

export const getAdjustPartnerAvailableErrorMessage = (error: any) => {
	const status = error?.response?.status;
	const data = error?.response?.data || {};
	const errorCode = data?.errorCode;
	const message = String(data?.message || error?.message || "");
	const normalizedMessage = message.toLowerCase();

	if (error?.code === "ECONNABORTED") {
		return "Case: STATION_BALANCE_CLIENT_TIMEOUT. The balance update did not respond in time. Please refresh this station balance before trying again.";
	}

	if (
		errorCode === "STATION_BALANCE_LOCK_CONFLICT" ||
		(status === 409 &&
			(normalizedMessage.includes("being updated by another request") ||
				normalizedMessage.includes("balance lock") ||
				normalizedMessage.includes("lock conflict")))
	) {
		return "Case: STATION_BALANCE_LOCK_CONFLICT. Station balance is locked by another request. Please wait a few seconds, then try again.";
	}

	if (
		errorCode === "STATION_BALANCE_STATEMENT_TIMEOUT" ||
		(status === 503 &&
			(normalizedMessage.includes("took too long") ||
				normalizedMessage.includes("statement timeout") ||
				normalizedMessage.includes("recalculating")))
	) {
		return "Case: STATION_BALANCE_STATEMENT_TIMEOUT. Database recalculation took too long. Please retry shortly.";
	}

	if (status === 524) {
		return "Case: STATION_BALANCE_GATEWAY_TIMEOUT. The balance update request timed out at the gateway. Please retry shortly.";
	}

	if (!error?.response) {
		return "Case: STATION_BALANCE_NETWORK_ERROR. Network error while updating station balance. Please check the connection and retry.";
	}

	return message || "Error adjusting balance";
};

export const adjustPartnerAvailable = async (
	id: string,
	amount: number,
	operation: "subtract" | "add",
	reason: string,
	attachments: string[] = [],
	balanceBeforeSnapshot?: number | null,
	hideFromStation: boolean = false
) => {
	const payload = {
		amount,
		operation,
		reason,
		attachments,
		balanceBeforeSnapshot,
		hideFromStation,
	};
	const { data } = await http.post(`/admin-partners/${id}/adjust-available`, payload, {
		timeout: 40000,
	});
	return data;
};

export const uploadPartnerBalanceAdjustmentFiles = async (files: File[]): Promise<string[]> => {
	if (!files || files.length === 0) {
		return [];
	}

	const formData = new FormData();
	files.forEach((file) => {
		formData.append("files", file);
	});

	const { data } = await http.post(
		"/gcs-upload-multiple-file?folder=documents/partner-balance-adjustments",
		formData,
		{
			headers: { "Content-Type": "multipart/form-data" },
		}
	);

	return (data || []).map((item: any) => item.path || item.url || item.filename).filter(Boolean);
};

export const subtractPartnerAvailable = async (id: string, amount: number) => {
	const { data } = await http.post(`/admin-partners/${id}/subtract-available`, {
		amount,
	});
	return data;
};

export type PartnerBalanceAdjustment = {
	id: number;
	partnerId: number;
	changedByUserId: number | null;
	operation: "add" | "subtract";
	amount: number;
	reason: string;
	attachments?: string[] | null;
	currencyCode: string | null;
	balanceBefore: number;
	balanceAfter: number;
	pendingAdjustmentBefore: number;
	pendingAdjustmentAfter: number;
	visibilityScope?: "station" | "admin";
	createdAt: string;
	updatedAt: string;
	changedByUser?: {
		id: number;
		fullName?: string | null;
		email?: string | null;
	} | null;
};

export type PartnerBalanceAdjustmentListResponse = {
	docs: PartnerBalanceAdjustment[];
	total: number;
	page: number;
	perPage: number;
	pages: number;
};

export const getPartnerBalanceAdjustments = async (
	id: string,
	page: number = 1,
	perPage: number = 20
): Promise<PartnerBalanceAdjustmentListResponse> => {
	const { data } = await http.get(`/admin-partners/${id}/balance-adjustments?page=${page}&perPage=${perPage}`);
	return data;
};

export const getPartnerDetail = async (id: string) => {
	let results = await http.get(`/partners-detail-by-admin/${id}`);

	const data = new Partner().parse(results.data);
	return data;
};

export const updateActivePartner = async (id: string, status: boolean) => {
	let results = await http.patch(`/deactive-partner/${id}`, {
		active: status ? false : true,
	});

	return results;
};

/** Hard-delete station (partner) when API allows — no orders / settlements / payment history. */
export const deletePartnerAdmin = async (id: string) => {
	const { data } = await http.delete(`/admin/partners/${id}`);
	return data;
};

export const ListDescriptionSearch = async (search: string) => {
	const { data } = await http.get(`/destination-search?search=${search}`);

	const res = new Partner().parseList(data);

	return res;
};

export const getUpdateImagePartner = async (
	id: string,
	meetStationImages: string[],
	nearbyStationImages: string[],
	imagesEnabled?: boolean
) => {
	let results = await http.put(`/admin-update-partner-images/${id}`, {
		meetStationImages,
		nearbyStationImages,
		images: meetStationImages,
		imagesEnabled: imagesEnabled,
	});

	return results;
};

export const updatePartnerWalkingDistance = async (partnerId: string, walkingDistance: string) => {
	let results = await http.put(`/admin-update-partner-walking-distance/${partnerId}`, {
		walkingDistance: walkingDistance,
	});
	return results;
};

export const uploadAvatarMutiImage = async (images: File[]) => {
	const formData = new FormData();
	const uploadUrl = "/gcs-upload-multiple-image?folder=partners/images";

	images.forEach((image) => {
		formData.append("images", image);
	});

	const { data } = await http.post(uploadUrl, formData);

	return data;
};

/**
 * Upload a single bag product image (Small / Medium / Large) to GCS.
 * Returns the public URL (or local fallback path) to store in imageSmall/imageMedium/imageLarge.
 */
export const uploadBagProductImage = async (file: File): Promise<string> => {
	const formData = new FormData();
	formData.append("image", file);

	const { data } = await http.post("/gcs-upload-single-image?folder=partners/bag-images", formData, {
		headers: { "Content-Type": "multipart/form-data" },
	});

	const url = data?.url || data?.path || data?.previewUrl;
	if (!url) {
		throw new Error("Upload thanh cong nhung khong nhan duoc URL anh.");
	}
	return url as string;
};

export const getListPartnerEmail = async (email: string, name?: boolean) => {
	const params: any = {
		...(email && { [name ? "userName" : "email"]: email }),
		limit: 1000,
	};
	let results = await http.get(`/partner-email-search?${new URLSearchParams(params).toString()}`);

	const res = new Partner().parseList(results.data);

	return res;
};

export const updatePartnerReviews = async (partnerId: string, reviews: any[]) => {
	let results = await http.put(`/admin-update-partner-reviews/${partnerId}`, {
		reviews: reviews,
	});
	return results;
};

const MIN_PAYOUT_LOCK_REASON = 20;

export { MIN_PAYOUT_LOCK_REASON };

export type PartnerPayoutLockAuditEntry = {
	id: number;
	partnerId: number;
	action: string;
	reason: string | null;
	changedByUserId: number | null;
	createdAt: string;
	changedByUser: { id: number; fullName: string; email: string } | null;
};

export async function lockOrUpdatePartnerPayoutLock(
	partnerId: string,
	reason: string
): Promise<{
	payoutLocked: boolean;
	payoutLockReason: string | null;
	payoutLockedAt: string | null;
	payoutLockedBy: number | null;
}> {
	const { data } = await http.post(`/admin-partners/${partnerId}/payout-lock`, { reason });
	return data;
}

export async function unlockPartnerPayoutLock(
	partnerId: string,
	note?: string
): Promise<{
	payoutLocked: boolean;
	payoutLockReason: string | null;
	payoutLockedAt: string | null;
	payoutLockedBy: number | null;
}> {
	const { data } = await http.delete(`/admin-partners/${partnerId}/payout-lock`, {
		data: note ? { note } : undefined,
	});
	return data;
}

export async function getPartnerPayoutLockAudit(
	partnerId: string,
	limit: number = 50,
	offset: number = 0
): Promise<{ total: number; data: PartnerPayoutLockAuditEntry[] }> {
	const { data } = await http.get(
		`/admin-partners/${partnerId}/payout-lock-audit?${new URLSearchParams({
			limit: String(limit),
			offset: String(offset),
		}).toString()}`
	);
	return data;
}

/* ── LƯU TRỮ station (Quân chốt 28/08/2026) ────────────────────────────────────
 * Archive KHÔNG xoá gì: đưa station về Closed + đánh dấu mốc đếm 90 ngày. Đối tác
 * vẫn đăng nhập được để xem lịch sử và rút nốt công nợ.
 *
 * `check` phải gọi TRƯỚC khi bấm — nó trả về CÓ ĐƯỢC PHÉP và VÌ SAO KHÔNG, để hộp
 * thoại nói thẳng lý do (còn 3 đơn chưa xong / còn công nợ) thay vì làm mờ nút rồi
 * để người dùng tự đoán.
 */
export const getStationArchiveCheck = async (
	id: string
): Promise<{ canArchive: boolean; reasons: string[] }> => {
	const res = await http.get(`admin/station-archive/check/${id}`);
	return res.data;
};

export const postStationArchive = async (id: string): Promise<{ ok: boolean; reasons?: string[] }> => {
	const res = await http.post(`admin/station-archive/${id}`, {});
	return res.data;
};

/* ══ Duyệt tài khoản ngân hàng của điểm — Quân duyệt 3 lớp 11/09/2026 ══
   Điểm khai ở cổng station, admin duyệt ở đây thì hệ mới tạo người nhận trên Wise
   và ghi vào hồ sơ điểm. Trước đó điểm đổi số tài khoản là ăn ngay, không ai duyệt. */

export type BankChangeRow = {
	id: number;
	partnerId: number;
	/** Tên điểm — mã số không thì admin không biết là ai (Quân 11/09). */
	station: {
		id: number;
		name: string | null;
		displayName: string | null;
		representativeEmail?: string | null;
		addressText?: string | null;
		destinationId?: string | null;
	};
	status: "PENDING" | "APPROVED" | "REJECTED";
	currency: string | null;
	/** Khai lần đầu (chưa có số nào trên hồ sơ). */
	laLanDau: boolean;
	/** APPROVED mà không có người duyệt = máy tự duyệt (khai lần đầu, Quân tick câu 1 11/09). */
	tuDong: boolean;
	daKhoaPayout: boolean;
	wiseRecipientId: string | number | null;
	/** `so` che 4 số cuối (dùng cho log); `soDayDu` = số đầy đủ để admin đối chiếu (Quân 11/09: "ko xem details thì duyệt kiểu gì"). */
	moi: { so: string; soDayDu: string | null; chu: string | null; nganHang: string | null };
	cu: { so: string; soDayDu: string | null; chu: string | null; nganHang: string | null; swift: string | null };
	/** Toàn bộ ô điểm đã khai (gồm phần máy tự điền từ hồ sơ). */
	chiTiet: {
		legalType: string | null;
		bankName: string | null;
		swiftCode: string | null;
		bankCode: string | null;
		accountType: string | null;
		accountNumber: string | null;
		accountHolderName: string | null;
		address: { country?: string; city?: string; firstLine?: string; postCode?: string; state?: string } | null;
	};
	createdAt: string;
	reviewedAt: string | null;
	rejectReason: string | null;
};

/** `auto=true` → chỉ các yêu cầu máy tự duyệt, để admin soát lại sau. */
export const getBankChangeRequests = async (status = "PENDING", auto = false) => {
	const { data } = await http.get(`/admin/bank-changes`, {
		params: auto ? { status: "APPROVED", auto: 1 } : { status },
	});
	return (data?.rows || []) as BankChangeRow[];
};

export const approveBankChange = async (id: number) => {
	const { data } = await http.post(`/admin/bank-changes/${id}/approve`, {});
	return data;
};

export const rejectBankChange = async (id: number, reason: string) => {
	const { data } = await http.post(`/admin/bank-changes/${id}/reject`, { reason });
	return data;
};

/* ══ Dòng thời gian một yêu cầu — Quân chốt 23/09/2026: "history về ngày giờ, loại máy
   và location" ngay trong Details để người duyệt thấy lúc cầm nút Approve. Chỉ ĐỌC audit. */
export type BankChangeTimelineStep = {
	key: "login" | "submitted" | "payout_locked" | "approved" | "auto_approved" | "rejected" | "status_changed";
	at: string;
	source: "station" | "admin" | "system";
	actorEmail: string | null;
	ip: string | null;
	/** Mã nước 2 chữ từ Cloudflare (CF-IPCountry) — chỉ có với bản ghi từ 23/09/2026. */
	country: string | null;
	device: { os: string | null; osVersion: string | null; browser: string | null; browserVersion: string | null; device: string; label: string };
	/** Tra ipinfo lúc mở: thành phố/vùng/nhà mạng. `source` = cloudflare-edge nghĩa là IP ghi trước 23/09, không định vị được. */
	location: { country: string | null; region: string | null; city: string | null; org: string | null; source: string; note?: string } | null;
	firstTime?: boolean;
	wiseRecipientId?: string | number | null;
	rejectReason?: string | null;
	note?: string;
};

export const getBankChangeTimeline = async (id: number) => {
	const { data } = await http.get(`/admin/bank-changes/${id}/timeline`);
	return (data?.steps || []) as BankChangeTimelineStep[];
};
